<template>
<div class="posterLocalCropper padding-20" v-if="dialogVisible">
    <el-dialog title="选择图片" :visible.sync="dialogVisible">
        <div class="select-box">
            <label class="btn" for="upload">选择图片</label>
            <div class="el-upload__tip">建议像素：750（宽）* 1334（高），JPG、PNG格式，大小不超过1M。</div>
        </div>
        <input type="file" id="upload" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event,2)">
        <cropper :cropperOption="cropperOption" ref="cropper" @getCanvas="getCanvas" v-if="imgBase"></cropper>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click.native="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Cropper from 'base/cropper/cropper'
import $ from 'jquery'
import {getUploadParam, qiniuFormUpload} from 'api/api'
import {data64toFile} from 'common/js/tools'
import {mapActions} from 'vuex'
export default {
    name: 'posterLocalCropper',
    data() {
        return {
            dialogVisible: false,
            imgBase: '',
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            }
        }
    },
    props: ['cropperOption', 'uploadType'],
    mounted() {
    },
    methods: {
        initUploadParam() {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        _getUploadParam() {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile()
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        getCanvas(img) {
            if (img) {
                this.imgBase = img
            }
        },
        cancel() {
            if (this.imgBase) {
                this.$refs.cropper.cancel()
            }
            this.imgBase = ''
            this.dialogVisible = false
        },
        submit() {
            if (this.uploadSetting.uploadauth) {
                this.uploadFile()
            } else {
                this._getUploadParam()
            }
        },
        uploadFile() {
            if (this.imgBase) {
                let img = data64toFile(this.imgBase, new Date().getTime())
                let formData = new FormData()
                formData.append('file', img)
                formData.append('key', this.uploadSetting.uploadfilekey)
                formData.append('token', this.uploadSetting.uploadauth)
                qiniuFormUpload({
                    url: this.uploadSetting.uploadurl,
                    data: formData,
                    success: (data) => {
                        this.$emit('setImage', Object.assign({}, data, this.fileOtherInfo))
                        this.cancel()
                    },
                    error: (data) => {
                        this.$message.error('上传失败，请重新上传')
                    }
                })
            } else {
                this.$message.error('请选择图片')
            }
        },
        openDialog() {
            this.imgBase = ''
            $('.cropper img').attr('src', '')
            this.dialogVisible = true
        },
        uploadImg (e, num) {
            // 上传图片
            var file = e.target.files[0]
            const isLt1M = file.size / 1024 / 1024 < 1
            if (!isLt1M) {
                this.$message.error('上传图片不能超过1MB!')
                return false
            }
            if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
                alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
                return false
            }
            var reader = new FileReader()
            reader.onload = (e) => {
                let data
                data = e.target.result
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]))
                } else {
                    data = e.target.result
                }
                this.imgBase = data
                this.$nextTick(() => {
                    if (num === 1) {
                        this.$refs.cropper.setCanvas(data)
                    } else if (num === 2) {
                        this.$refs.cropper.setCanvas(data)
                    }
                })
                document.getElementById('upload').value = ''
            }
            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blobcs
            reader.readAsArrayBuffer(file)
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Cropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.posterLocalCropper {
    .el-dialog{
        width: 800px;
    }
    .select-box{
        @include flexBox(flex-start);
        margin-bottom: 20px;
        .btn {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            text-align: center;
            box-sizing: border-box;
            outline: none;
            margin:0 5px;
            padding: 8px 15px;
            font-size: 14px;
            border-radius: 4px;
            color: $tcolor-gray;
            background: $bgcolor-white;
            border: 1px solid $line;
            transition: all .2s ease;
            text-decoration: none;
            user-select: none;
        }
    }
}
</style>
